<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">Industry Data</strong>
        </div>
        <div class="col-md-2">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5">
        <div class="col-md-6">
          <div class="form-group">
            <!-- <input type="text" v-model="searchParams.sectorname" class="form-control" name="sector" placeholder="Search by Sector"/> -->
            <!-- <select class="form-control" name="sector" v-model="selIndCode" @change="getIndustryData">
                <option value="0">Select Industry</option>
                <option
                  v-for="(inds, index) in industryList"
                  :value="inds.IndustryCode"
                  v-bind:key="inds.IndustryCode+index"
                >{{inds.IndustryName}}</option>
            </select>-->
            <v-select
              :options="industryList"
              :placeholder="'Select Industry'"
              :label="'IndustryName'"
              v-model="selIndCode"
              @input="getIndustryData"
            ></v-select>
          </div>
        </div>
        <div class="col-md-4"></div>
        <div class="col-md-2">
          <!-- <download :tableId="'industry'" :fileName="'industry-data'"></download> -->
        </div>
      </div>
      <vue-tabs
        v-model="selTab"
        direction="horizontal"
        @tab-change="getTabData"
        v-if="selIndCode!==''"
      >
        <v-tab :title="'Ratios'">
          <div class="row mb5 mt15">
            <div class="col-md-10"></div>
            <div class="col-md-2">
              <download :tableId="'industry-ratios'" :fileName="'industry-ratios'"></download>
            </div>
          </div>
          <div class="table-responsive app" v-dragscroll="true">
            <table
              id="industry-ratios"
              class="table table-bordered fonts11 app-inner"
              v-if="(industry.length>0)"
            >
              <thead></thead>
              <tbody>
                <tr>
                  <td>Industry Code</td>
                  <td>{{industry[0][this.tableColumns[(this.tableColumns.length-1)].title].ind_code}}</td>
                </tr>
                <tr>
                  <td>Industry Name</td>
                  <td>{{industry[0][this.tableColumns[(this.tableColumns.length-1)].title].IndustryName}}</td>
                </tr>
              </tbody>
              <br>
              <thead>
                <tr>
                  <th></th>
                  <th v-for="tc in tableColumns" v-bind:key="'tc'+tc.title">{{tc.name}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="tr in tableRows" v-bind:key="'tr'+tr.title">
                  <td>{{tr.name}}</td>
                  <td
                    v-for="cl in tableColumns"
                    v-bind:key="'cldata'+cl.title"
                  >{{industry[cl.orgKey][cl.title][tr.title]}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-tab>
        <v-tab :title="'Quarterly Results'">
          <div class="row mb5 mt15">
            <div class="col-md-10"></div>
            <div class="col-md-2">
              <download :tableId="'industry-qtr-results'" :fileName="'industry-qtr-results'"></download>
            </div>
          </div>
          <div class="table-responsive app" v-dragscroll="true">
            <table
              id="industry-qtr-results"
              class="table table-bordered w70 fonts11 app-inner"
              v-if="(industry.length>0)"
            >
              <thead></thead>
              <tbody>
                <tr>
                  <td>Industry Code</td>
                  <td>{{industry[0][this.tableColumns[(this.tableColumns.length-1)].title].ind_code}}</td>
                </tr>
                <tr>
                  <td>Industry Name</td>
                  <td>{{industry[0][this.tableColumns[(this.tableColumns.length-1)].title].IndustryName}}</td>
                </tr>
              </tbody>
              <br>
              <br>
              <thead>
                <tr>
                  <th>Quarter</th>
                  <th>Net Sales</th>
                  <th>Net Profit</th>
                  <th>EPS</th>
                </tr>
              </thead>
              <tbody v-for="field1 in ind_quarters " v-bind:key="field1.title+'qtr'">
                <tr v-if="field1.title && qtrResults.eps[field1.title] ">
                  <td>{{field1.name}}</td>
                  <td>{{(qtrResults.sales)? getFixed(qtrResults.sales[field1.title]): '-'}}</td>
                  <td>{{(qtrResults.profit)? getFixed(qtrResults.profit[field1.title]): '-'}}</td>
                  <td>{{(qtrResults.eps)? getFixed(qtrResults.eps[field1.title]): '-'}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-tab>
        <v-tab :title="'Companies List'">
          <div class="row mb5 mt15">
            <div class="col-md-10"></div>
            <div class="col-md-2">
              <download :tableId="'companies-list'" :fileName="'companies-list'"></download>
            </div>
          </div>
          <div class="table-responsive app" v-dragscroll="true">
            <table
              id="companies-list"
              class="table table-bordered w70 fonts11 app-inner"
              v-if="(industry.length>0)"
            >
              <thead></thead>
              <tbody>
                <tr>
                  <td>Industry Code</td>
                  <td>{{industry[0][this.tableColumns[(this.tableColumns.length-1)].title].ind_code}}</td>
                </tr>
                <tr>
                  <td>Industry Name</td>
                  <td>{{industry[0][this.tableColumns[(this.tableColumns.length-1)].title].IndustryName}}</td>
                </tr>
              </tbody>
              <br>
              <br>
              <thead>
                <th v-for="(fld, ind) in tableFields" v-bind:key="ind+'fld'">{{fld.name}}</th>
              </thead>
              <tbody>
                <tr v-for="(comp, index) in companies " v-bind:key="index+'comp'">
                  <td v-for="(fld, ind) in tableFields" v-bind:key="ind+'fld'">{{comp[fld.title]}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-tab>
      </vue-tabs>
    </div>
  </div>
</template>

<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
export default {
  name: "Company",
  created() {
    this.getIndustries();
  },
  mixins: [commonMixins],
  data() {
    return {
      industry: [],
      industryList: [],
      tableColumns: [],
      tableRows: [],
      selIndCode: "",
      selTab: "",
      ind_quarters: [],
      qtrResults: { eps: [], profit: [], sales: [] },
      tableFields: [],
      companies: []
    };
  },
  methods: {
    getIndustries() {
      let _this = this;
      http.get("getIndustryMaster", {}, function(error, response) {
        console.log("getIndustries Data", response);
        _this.industryList = response;
        if (_this.industryList.length > 0) {
          if (!localStorage.getItem("industry")) {
            _this.selIndCode = _this.industryList[0];
            localStorage.setItem(
              "industry",
              JSON.stringify(_this.selIndCode)
            );
          } else {
            _this.selIndCode = JSON.parse(localStorage.getItem("industry"));
          }
          // _this.getIndustryData();
          // _this.getQtrResults();
          // _this.getCompaniesList();
        }
      });
    },
    getIndustryData() {
      if (this.selIndCode !== "") {
        localStorage.setItem("industry", JSON.stringify(this.selIndCode));
        this.getIndustryRatios();
        this.getQtrResults();
        this.getCompaniesList();
      }
    },
    getIndustryRatios() {
      let url = "getIndustryRatios/" + this.selIndCode.IndustryCode;
      http.get(url, {}, (error, response) => {
        if (error === null) {
          if (response.length > 0) {
            this.tableColumns = [];
            this.tableRows = [];
            this.industry = response;
            this.industry.forEach((val, key) => {
              var columns = Object.keys(val);
              if (columns[0] !== "company_name" && columns[0] !== "co_code") {
                this.tableColumns.push({
                  title: columns[0],
                  name: columns[0],
                  orgKey: key,
                  sort_order: parseInt(columns[0])
                });
              }
            });
            var rowKeys = Object.keys(
              this.industry[0][this.tableColumns[0].title]
            );
            console.log("rowKeys", rowKeys);
            rowKeys.forEach((val, key) => {
              if (
                val !== "_id" &&
                val !== "ind_code" &&
                val !== "IndustryName" &&
                val !== "YearRC"
              ) {
                this.tableRows.push({
                  title: val,
                  name: this.getrowLabel(val),
                  sort_order: key
                });
              }
            });
            console.log(this.tableColumns);
            this.tableColumns = this.sorted_fields_desc(
              this.tableColumns,
              "sort_order"
            );
            this.tableRows = this.sorted_fields_asc(
              this.tableRows,
              "sort_order"
            );
            console.log(this.tableRows);
          }
        }
      });
    },
    getQtrResults() {
      let url = "getIndustryWiseData";
      var _this = this;
      http.post(
        url,
        { ind_code: this.selIndCode.IndustryCode },
        (error, response) => {
          if (error === null) {
            if (response.length > 0) {
              _this.qtrResults = response[0];
              var qtrFieldsList = [];
              if (response.length > 0 && response[0].eps) {
                var salesQtr = Object.keys(response[0].eps);
                for (let qtrField in salesQtr) {
                  qtrFieldsList.push({
                    title: salesQtr[qtrField],
                    name: _this.getQuarterStringAddCalender(salesQtr[qtrField]),
                    sort_order: _this.getQuarterDigits(salesQtr[qtrField])
                  });
                }
                _this.ind_quarters = _this.sorted_fields_desc(
                  qtrFieldsList,
                  "sort_order"
                );
                console.log(_this.ind_quarters, _this.qtrResults);
              }
            }
          }
        }
      );
    },
    getCompaniesList() {
      let url = "getIndustryWiseCompanies";
      var _this = this;
      http.post(
        url,
        { ind_code: this.selIndCode.IndustryCode },
        (error, response) => {
          if (error === null) {
            if (response.length > 0) {
              _this.tableFields = [];
              console.log(response);
              _this.companies = response;
              var tableFields = Object.keys(response[0]);
              tableFields.forEach((val, key) => {
                if (val !== "sectorname") {
                  _this.tableFields.push({
                    title: val,
                    name: _this.getCustomLabel(val)
                      ? _this.getCustomLabel(val)
                      : _this.getLabel(val),
                    sort_order:
                      val === "co_code" ? 0 : val === "companyname" ? 1 : 2
                  });
                }
              });
              _this.tableFields = _this.sorted_fields_asc(
                _this.tableFields,
                "sort_order"
              );
            }
          }
        }
      );
    },
    getTabData(tabIndex, newTab, oldTab) {
      console.log("TabChange", this.selTab, tabIndex, newTab, oldTab);
      if (tabIndex === 1) {
        // this.getQtrResults();
      } else if (tabIndex === 2) {
        // this.getCompaniesList();
      } else {
        // this.getIndustryData();
      }
    }
  }
};
</script>
<style>
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/industry/industryData.vue